module.exports = __webpack_public_path__ + "images/attention-b09178a7.svg";